export const FORM_CONSTANTS = {
    ACCEPTED_FILES: 'JPG, JPEG of PNG',
    ACCEPTED_FILESIZE: 'Max 2mb',
    CROP_IMAGE: 'Afbeelding bijwerken',
    DRAG_IMAGE: 'Sleep je afbeelding hier in, of',
    UPLOAD: 'upload',
    UPLOAD_IMAGE: 'Afbeelding uploaden',
}